import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatformApiModule } from '@data/_generated-api/platform-api/platform-api.module';
import { registerSchemas } from '@common/mapper';
import { coreDataSchemas } from '@/app/platform/platform-data/mapper';
import { EgiPageSelectComponent } from '@/app/platform/platform-data/components/form-controls/formly/egi-page-select/egi-page-select.component';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { NavigationItemTypeTagComponent } from './components/atoms/navigation-item-type-tag/navigation-item-type-tag.component';
import { EgiPageInfoComponent } from './components/atoms/egi-page-info/egi-page-info.component';
import { NavigationItemLabelComponent } from './components/molecules/navigation-item-label/navigation-item-label.component';
import { EgiAppSelectComponent } from './components/form-controls/egi-app-select/egi-app-select.component';
import { SynchronizeAppNavigationItemsButtonComponent } from './components/atoms/synchronize-app-navigation-items-button/synchronize-app-navigation-items-button.component';
import { FeatureLabelComponent } from './components/atoms/feature-label/feature-label.component';
import { NavigationItemConflictsIndicatorComponent } from './components/atoms/navigation-item-conflicts-indicator/navigation-item-conflicts-indicator.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MultiLanguageModule } from '@/app/multi-language.module';
import { platformDataProviders } from '@/app/platform/platform-data/platform-data.providers';
import { environment } from '@/environments/environment';
import { PopoverModule } from '@ngx-popovers/popover';
import { UserSelectComponent } from '@/app/platform/platform-data/components/form-controls/formly/user-select/user-select.component';

@NgModule({
  declarations: [
    EgiPageSelectComponent,
    NavigationItemTypeTagComponent,
    EgiPageInfoComponent,
    NavigationItemLabelComponent,
    EgiAppSelectComponent,
    SynchronizeAppNavigationItemsButtonComponent,
    FeatureLabelComponent,
    NavigationItemConflictsIndicatorComponent,
    UserSelectComponent
  ],
  imports: [
    CommonModule,
    PlatformApiModule.forRoot({
      rootUrl: environment.apiPaths.egituraPlatformApi
    }),

    FormlyModule.forRoot({
      types: [
        {
          name: 'egi-page-select',
          component: EgiPageSelectComponent
        },
        {
          name: 'user-select',
          component: UserSelectComponent
        }
      ]
    }),
    ReactiveFormsModule,
    SharedModule,

    NgSelectModule,
    MultiLanguageModule,
    PopoverModule
  ],
  exports: [
    NavigationItemTypeTagComponent,
    EgiPageInfoComponent,
    NavigationItemLabelComponent,
    EgiAppSelectComponent,
    SynchronizeAppNavigationItemsButtonComponent,
    FeatureLabelComponent,
    NavigationItemConflictsIndicatorComponent
  ],
  providers: platformDataProviders
})
export class PlatformManagementDataModule {
  constructor() {
    registerSchemas(coreDataSchemas);
  }
}
